import React, { useId } from 'react';
import { useMenuIconAnimation } from './useMenuIconAnimation';
import './ContactsAnimatedIcon.css';

const BOOK_PATH = 'M8.05867 21.0145C8.05867 21.3726 8.16057 21.5155 8.42705 21.5155C9.02097 21.5155 9.39916 20.7587 9.39916 19.5C9.39916 17.5763 7.99727 16.6553 6.24704 16.6553C4.44649 16.6553 2.80882 17.8628 2.80882 20.1447C2.80882 22.3243 4.24141 23.5113 6.44146 23.5113C7.18845 23.5113 7.68986 23.4294 8.45689 23.1736L8.62147 23.8588C7.86424 24.1048 7.055 24.176 6.43123 24.176C3.54558 24.176 2 22.5899 2 20.1443C2 17.6782 3.79117 16 6.25727 16C8.8257 16 10.1862 17.5349 10.1862 19.4178C10.1862 21.0141 9.68525 22.2318 8.1094 22.2318C7.39268 22.2318 6.9224 21.9453 6.861 21.3104C6.67681 22.0165 6.18564 22.2318 5.52008 22.2318C4.62983 22.2318 3.88283 21.5457 3.88283 20.1647C3.88283 18.7731 4.53816 17.9135 5.71493 17.9135C6.33913 17.9135 6.72798 18.1591 6.90108 18.548L7.19826 18.0056H8.05781V21.0145H8.05867ZM6.80046 19.6638C6.80046 19.1014 6.38049 18.8656 6.03257 18.8656C5.65396 18.8656 5.23484 19.1722 5.23484 20.0731C5.23484 20.7894 5.55206 21.1885 6.03257 21.1885C6.37025 21.1885 6.80046 20.9736 6.80046 20.3801V19.6638Z';

const LINES_PATH = 'M10.1762 8.03838L23.1804 11.8152C23.4268 11.8867 23.6346 12.0532 23.7582 12.278C23.8818 12.5028 23.911 12.7675 23.8395 13.0138L21.1418 22.3025C21.0702 22.5489 20.9037 22.7567 20.679 22.8803C20.4542 23.0039 20.1895 23.0332 19.9431 22.9616L10.5331 20.2287C10.6755 19.9391 10.773 19.6287 10.818 19.3042L19.4977 21.825L17.1164 17.4873L17.9614 17.0226L20.3869 21.4336L22.7474 13.306L15.1155 17.4753C14.8912 17.5977 14.6276 17.6264 14.3822 17.5552C14.1368 17.4839 13.9296 17.3184 13.8058 17.0949L9.70144 9.67319L7.97429 15.6201C7.66319 15.5477 7.33669 15.5084 7 15.5067L8.9776 8.69748C9.04915 8.45113 9.21563 8.24329 9.44042 8.11969C9.66521 7.99608 9.92989 7.96684 10.1762 8.03838ZM22.1582 12.5255L10.5149 9.14395L14.6522 16.6256L22.1582 12.5255';

const ENVELOPE_BODY = 'M7 15.5067 L7.97429 15.6201 L9.70144 9.67319 L10.1762 8.03838 L23.1804 11.8152 C23.4268 11.8867 23.6346 12.0532 23.7582 12.278 C23.8818 12.5028 23.911 12.7675 23.8395 13.0138 L21.1418 22.3025 C21.0702 22.5489 20.9037 22.7567 20.679 22.8803 C20.4542 23.0039 20.1895 23.0332 19.9431 22.9616 L10.5331 20.2287 L7 15.5067 Z';

// const ENVELOPE_LINES = [
//   'M9.70144 9.67319 L13.8058 17.0949',
//   'M10.5149 9.14395 L14.6522 16.6256',
//   'M22.1582 12.5255 L14.6522 16.6256',
//   'M22.7474 13.306 L15.1155 17.4753',
// ];
const ENVELOPE_LINES = [
  // левый верх → центр (подняли Y)
  'M7 2.2 L14.6522 16.6256',

  // центр → правый верх
  'M14.6522 16.6256 L23 12.8152',
];

const ARROW_PATH = 'M9.62545 16.4238C9.88623 16.6381 10.113 16.8837 10.2981 17.1537L12.2073 16.0615L11.726 15.2217L9.62545 16.4238Z';

const ARROW_MIRROR_PATH = 'M19.4977 21.825 L17.1164 17.4873 L17.9614 17.0226 L20.3869 21.4336 Z';

const AVATAR_PATH = 'M4.26117 16.2307L0.971401 15.8569C0.735843 15.8302 0.519161 15.7152 0.365081 15.5351C0.211002 15.3549 0.130996 15.123 0.141205 14.8862C0.158832 14.4767 0.182269 14.1432 0.211515 13.8858C1.14565 5.66418 8.56703 -0.242839 16.7887 0.691295C17.0454 0.720471 17.3756 0.772438 17.7793 0.847199C18.0124 0.890384 18.2204 1.02038 18.3614 1.21095C18.5024 1.40152 18.5659 1.63848 18.539 1.87401L18.1652 5.16378C18.1522 5.27919 18.0968 5.38566 18.0097 5.46249C17.9226 5.53932 17.8101 5.58104 17.6939 5.57953C17.4782 5.57638 17.3047 5.57677 17.1736 5.58072C15.8623 5.619 14.5642 5.85532 13.3235 6.28167C13.1274 6.34891 12.9116 6.26597 12.8116 6.08497L11.605 3.91424C8.60535 4.81708 6.06696 6.8375 4.51418 9.55819L6.35539 11.2186C6.43093 11.2863 6.48018 11.3784 6.49445 11.4788C6.50873 11.5792 6.48713 11.6815 6.43345 11.7675C5.74069 12.8809 5.22017 14.0926 4.88953 15.3616C4.85626 15.4885 4.81704 15.6568 4.77185 15.8665C4.74706 15.9798 4.68109 16.0799 4.58672 16.1474C4.49235 16.2148 4.37641 16.2439 4.26117 16.2307Z';

const ACTIVE_COLOR = '#3262FF';
const INACTIVE_COLOR = '#282932';

function ContactsAnimatedIcon({ color, isActive = false, size = 24 }) {
  const strokeColor = color || (isActive ? ACTIVE_COLOR : INACTIVE_COLOR);
  const clipId = useId();
  const { playing, handleClick } = useMenuIconAnimation(isActive, 1100);

  const showActiveEnvelope = isActive && !playing;

  return (
    <span
      className={[
        'contacts-animated-icon',
        playing ? 'contacts-animated-icon--playing' : '',
        showActiveEnvelope ? 'contacts-animated-icon--active' : '',
      ].filter(Boolean).join(' ')}
      style={{ '--contacts-icon-fill': strokeColor, width: size, height: size }}
      onClick={handleClick}
      role="presentation"
    >
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <g clipPath={`url(#${clipId})`}>
          <path className="contacts-icon-path contacts-icon-book" d={BOOK_PATH} />

          {showActiveEnvelope ? (
            <g className="contacts-icon-envelope">
              <path className="contacts-icon-envelope-body" d={ENVELOPE_BODY} />
              {ENVELOPE_LINES.map((d) => (
                <path key={d} className="contacts-icon-envelope-line" d={d} />
              ))}
            </g>
          ) : (
            <path
              className="contacts-icon-path contacts-icon-lines"
              fillRule="evenodd"
              clipRule="evenodd"
              d={LINES_PATH}
            />
          )}

          <path className="contacts-icon-path contacts-icon-arrow" d={ARROW_PATH} />
          <path className="contacts-icon-path contacts-icon-arrow-mirror" d={ARROW_MIRROR_PATH} />
          <path className="contacts-icon-path contacts-icon-avatar" d={AVATAR_PATH} />
        </g>

        <defs>
          <clipPath id={clipId}>
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </span>
  );
}

export default ContactsAnimatedIcon;